import TextColorPanel from './toolbar/TextColorPanel';

const Modals = {
  TEXT_COLOR_PICKER: 'TEXT_COLOR_PICKER',
};

const ModalsMap = {
  [Modals.TEXT_COLOR_PICKER]: TextColorPanel,
};

export { Modals, ModalsMap };
